import React, { useContext } from 'react';
import _ from 'underscore';
import {
  Button,
  mergeClasses,
  makeStyles,
  tokens,
  shorthands,
} from '@fluentui/react-components';
import { CopilotIcon } from '@bingads-webui-react/copilot-ui-base';
import { PermissionsContext } from '@bingads-webui-react/hoc-with-permissions';

type InsightsButtonProps = {
  label: string;
  onClick: (event: any) => void;
  className?: string;
};

export const useInsightsButtonStyles = makeStyles({
  button: {
    height: '26px',
    paddingTop: tokens.spacingVerticalXXS,
    paddingBottom: tokens.spacingVerticalXXS,
    paddingLeft: tokens.spacingHorizontalXS,
    paddingRight: tokens.spacingHorizontalXS,
    fontWeight: tokens.fontWeightRegular,
    fontSize: tokens.fontSizeBase200,
    textAlign: 'center',
    ...shorthands.borderWidth('1.5px !important'),
  },
  copilotIcon: {
    paddingLeft: '0 !important',
  },
});

export const InsightsButton: React.FC<InsightsButtonProps> = ({ label, onClick, className }) => {
  const styles = useInsightsButtonStyles();
  const permissions = useContext(PermissionsContext);

  return (
    <Button
      onClick={onClick}
      className={mergeClasses('insights-button', styles.button, className)}
    >
      <CopilotIcon
        size="small"
        color={_.get(permissions, ['dynamic', 'AdsCopilotUxImprovements']) ? 'multicolor' : 'blue'}
        iconStyles={styles.copilotIcon}
      />
      {label}
    </Button>
  );
};
